import { render, staticRenderFns } from "./PageForgotPassword.vue?vue&type=template&id=2351aaa6"
import script from "./PageForgotPassword.vue?vue&type=script&lang=js"
export * from "./PageForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./PageForgotPassword.vue?vue&type=style&index=0&id=2351aaa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports